import { render, staticRenderFns } from "./TextSelection.vue?vue&type=template&id=c7676de4"
import script from "./TextSelection.vue?vue&type=script&lang=js"
export * from "./TextSelection.vue?vue&type=script&lang=js"
import style0 from "./TextSelection.vue?vue&type=style&index=0&id=c7676de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports